export interface FaqDefinition {
  id: string;
  category: 'pairing' | 'connectivity' | 'events' | 'recording' | 'sharing' | 'account';
  titleKey: string;
  bodyKey: string;
  keywords: string[];
  models?: string[];
}

export interface ResolvedFaq extends FaqDefinition {
  title: string;
  body: string;
}

export const FAQ_DEFINITIONS: FaqDefinition[] = [
  { id: 'pair-device', category: 'pairing', titleKey: 'support.faqPairTitle', bodyKey: 'support.faqPairBody', keywords: ['pair', 'qr', 'ble', '配對', '綁定'] },
  { id: 'device-offline', category: 'connectivity', titleKey: 'support.faqOfflineTitle', bodyKey: 'support.faqOfflineBody', keywords: ['offline', 'wifi', 'network', '離線', '網路'] },
  { id: 'notifications', category: 'events', titleKey: 'support.faqNotifyTitle', bodyKey: 'support.faqNotifyBody', keywords: ['notification', 'push', 'event', '通知', '事件'] },
  { id: 'recording-playback', category: 'recording', titleKey: 'support.faqRecordingTitle', bodyKey: 'support.faqRecordingBody', keywords: ['recording', 'playback', 'sd', 'cloud', '錄影', '回放'] },
  { id: 'share-device', category: 'sharing', titleKey: 'support.faqShareTitle', bodyKey: 'support.faqShareBody', keywords: ['share', 'invite', 'family', '共用', '邀請'] },
  { id: 'battery-camera', category: 'connectivity', titleKey: 'support.faqBatteryTitle', bodyKey: 'support.faqBatteryBody', keywords: ['battery', 'sleep', 'wake', '電池', '休眠'], models: ['ls-2602'] },
];

export function resolveFaqs(t: (key: string) => string): ResolvedFaq[] {
  return FAQ_DEFINITIONS.map((faq) => ({ ...faq, title: t(faq.titleKey), body: t(faq.bodyKey) }));
}

export function searchFaqs(faqs: ResolvedFaq[], query: string, model?: string): ResolvedFaq[] {
  const q = query.trim().toLocaleLowerCase();
  const normalizedModel = model?.trim().toLocaleLowerCase();
  return faqs.filter((faq) => {
    if (faq.models?.length && (!normalizedModel || !faq.models.some((m) => m.toLocaleLowerCase() === normalizedModel))) return false;
    if (!q) return true;
    return [faq.title, faq.body, faq.category, ...faq.keywords].join('\n').toLocaleLowerCase().includes(q);
  });
}
